import type { Country } from '@tectonics/prs/country/country-registry';
import type { CountrySchema } from './types';
import { zambiaCountrySchema } from '@tectonics/prs/zambia/country-schema';
import { coteDivoireCountrySchema } from '@tectonics/prs/cote-divoire/country-schema';
import { senegalCountrySchema } from '@tectonics/prs/senegal/country-schema';
import { createCountrySchemaRegistry } from './create-registry';

// Register a country by importing its schema here and adding it to the list.
const countrySchemas: readonly CountrySchema[] = [zambiaCountrySchema, coteDivoireCountrySchema, senegalCountrySchema];

export const countrySchemaRegistry: Map<Country, CountrySchema> =
  createCountrySchemaRegistry(countrySchemas);

export const registeredCountries = new Set(countrySchemaRegistry.keys());

export default countrySchemaRegistry;
